// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stories_main_section__pd2xy {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
}


@media screen and (max-width: 768px) {
  .stories_main_section__pd2xy {
    width: 93vw; 
    height: auto; 
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Stroies/stories.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;;AAGA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".main_section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: auto;\n}\n\n\n@media screen and (max-width: 768px) {\n  .main_section {\n    width: 93vw; \n    height: auto; \n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_section": `stories_main_section__pd2xy`
};
export default ___CSS_LOADER_EXPORT___;
